<script>
	import { Table } from "sveltestrap";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { convert } from "../../../services/helpers";
	import { navigate } from "svelte-routing";

	export let data;

	const last_updated = new Date();
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Data Name</th>
				<th>Last Edited</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { name, route }}
				<tr>
					<td>
						<p
							class="link"
							on:click={() => navigate(route)}
							on:keydown={() => {}}
						>
							<span class="link link-text">
								{name}
							</span>
						</p>
					</td>
					<td>
						{convert(last_updated)}
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.length === 0}
		<p class="text-center">No data to display</p>
	{/if}
	<!-- <CustomPaginate totalRecord={data.length}/> -->
</LoaderContainer>
